import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@readsavor/api-client';
import { useAuthStore, userQueryKeys } from '@readsavor/auth';
/**
 * Stable query keys for the user's current subscription cycle.
 */
export const subscriptionCycleQueryKeys = {
    all: ['subscriptionCycle'],
    current: () => [...userQueryKeys.all, ...subscriptionCycleQueryKeys.all, 'current'],
};
/**
 * Fetches the current user's active subscription cycle.
 * This query is enabled only when a valid session exists.
 */
export const useSubscriptionCycle = () => {
    const status = useAuthStore(state => state.status);
    const isInitializationComplete = useAuthStore(state => state.isInitializationComplete);
    return useQuery({
        queryKey: subscriptionCycleQueryKeys.current(),
        queryFn: () => apiClient.subscription.getCurrentCycle(),
        // This query is only enabled after the initial session check is complete
        // and the user initialization process has finished.
        enabled: status === 'authenticated' && isInitializationComplete,
        staleTime: 5 * 60 * 1000, // 5 minutes
        // Add retry logic to handle the race condition on initial load
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 10000), // Exponential backoff
    });
};
//# sourceMappingURL=useSubscriptionCycle.js.map